const taxCreditUrl =
  'https://www.irs.gov/credits-deductions/used-clean-vehicle-credit';

export default taxCreditUrl;
